export default "__VITE_ASSET__9XAiIfWI__"